export * from './ai-recommendations';
export * from './alert-settings';
export * from './grid-operators';
export * from './gse-tariffs';
export * from './hourly-profile';
export * from './italian-regions';
export * from './member-types';
export * from './monthly-curve';
export * from './weekly-summary';
export * from './gse-glossary';

/**
 * Opzioni per `toLocaleString('it-IT', IT_INT)`: il punto delle migliaia anche
 * a quattro cifre. Senza, l'italiano scrive «1091» ma «23.584» (N-15).
 */
export const IT_INT = { useGrouping: 'always' } as const satisfies Intl.NumberFormatOptions;
export {
	isAutomaticNotification,
	NOTIFICATION_TIPO_LABEL,
	notificationTipoLabel,
	type NotificationTipo,
} from './notification-types';
